<template>
  <div class="filters-section-container flex flex-col">
    <div class="section flex justify-between">
      <h2 class="text-color-gray flex items-center w-full">
        {{ $t("wegow.filters.title").toUpperCase() }}
        <span
          ><img
            class=" ml-2"
            :src="require('@/assets/images/ic-filter-grey.svg')"
            :alt="$t('wegow.filters.closeIconAlt')"
        /></span>
      </h2>
      <span class="close-icon cursor-pointer md:hidden" @click="closeSection()">
        <img
          :src="require('@/assets/images/modal-cross.png')"
          :alt="$t('wegow.filters.closeIconAlt')"
        />
      </span>
    </div>
    <div
      v-if="openedSections && !simple"
      class="section flex flex-col space-y-4"
    >
      <wegow-checkbox
        id="get-type-concert"
        class="w-[13px]"
        :value="
          localFilters.type === 'concerts' || localFilters.type === 'both'
        "
        :title="$t('wegow.filters.concerts')"
        size-width="13px"
        size-height="13px"
        top="3px"
        @update:value="changeType(localFilters.type, 'concerts')"
      />
      <wegow-checkbox
        id="get-type-festival"
        :value="
          localFilters.type === 'festivals' || localFilters.type === 'both'
        "
        :title="$t('wegow.filters.festivals')"
        size-width="13px"
        size-height="13px"
        top="3px"
        @update:value="changeType(localFilters.type, 'festivals')"
      />
      <wegow-checkbox
        id="get-type-artist"
        :value="localFilters.type === 'artists'"
        :title="$t('wegow.filters.artists')"
        size-width="13px"
        size-height="13px"
        top="3px"
        @update:value="changeType(localFilters.type, 'artists')"
      />
      <wegow-checkbox
        id="get-type-venue"
        :value="localFilters.type === 'venues'"
        :title="$t('wegow.filters.venues')"
        size-width="13px"
        size-height="13px"
        top="3px"
        @update:value="changeType(localFilters.type, 'venues')"
      />
      <wegow-checkbox
        id="get-type-pages"
        :value="localFilters.type === 'pages'"
        :title="$t('wegow.filters.companies')"
        size-width="13px"
        size-height="13px"
        top="3px"
        @update:value="changeType(localFilters.type, 'pages')"
      />
      <wegow-checkbox
        id="get-type-users"
        :value="localFilters.type === 'users'"
        :title="$t('wegow.filters.people')"
        size-width="13px"
        size-height="13px"
        top="3px"
        @update:value="changeType(localFilters.type, 'users')"
      />
      <!-- TODO: revisar filtros de pages -->
    </div>
    <div
      v-if="
        openedSections &&
          (localFilters.type === 'concerts' ||
            localFilters.type === 'festivals' ||
            localFilters.type === 'both')
      "
      class="section flex flex-col space-y-4"
    >
      <span class="flex justify-between items-center">
        <h3>{{ $t("wegow.filters.date") }}</h3>
        <button>
          <img
            :src="require('@/assets/images/ic-calendar-circle-grey.svg')"
            alt="calendar icon"
            @click="changeDate('personalized')"
          />
        </button>
      </span>

      <wegow-checkbox
        id="get-today-data"
        :value="localFilters.date === 'today'"
        :title="$t('wegow.filters.today')"
        size-width="13px"
        size-height="13px"
        top="3px"
        @update:value="changeDate('today')"
      />
      <wegow-checkbox
        id="get-tomorrow-data"
        :value="localFilters.date === 'tomorrow'"
        :title="$t('wegow.filters.tomorrow')"
        size-width="13px"
        size-height="13px"
        top="3px"
        @update:value="changeDate('tomorrow')"
      />
      <wegow-checkbox
        id="get-week-data"
        :value="localFilters.date === 'week'"
        :title="$t('wegow.filters.week')"
        size-width="13px"
        size-height="13px"
        top="3px"
        @update:value="changeDate('week')"
      />
      <wegow-checkbox
        id="get-weekend-data"
        :value="localFilters.date === 'weekend'"
        :title="$t('wegow.filters.weekend')"
        size-width="13px"
        size-height="13px"
        top="3px"
        @update:value="changeDate('weekend')"
      />
      <wegow-checkbox
        id="get-month-data"
        :value="localFilters.date === 'month'"
        :title="$t('wegow.filters.month')"
        size-width="13px"
        size-height="13px"
        top="3px"
        @update:value="changeDate('month')"
      />
      <!-- <wegow-checkbox
        id="get-personalized-data"
        :value="showPersonalizatedDate"
        :title="$t('wegow.filters.personalized')"
        size-width="13px"
        size-height="13px"
        top="3px"
        @update:value="changeDate('personalized')"
      /> -->
      <div v-if="showPersonalizatedDate" class="flex w-3/4 flex-col space-y-2">
        <wegow-input
          id="profile-user-birthdate"
          :value="localFilters.from_date"
          :label="$t('wegow.filters.fromDate')"
          :small-label="true"
          type="date"
          background-input="bg-transparent"
          @update:value="checkDate($event, 'from_date')"
        />
        <wegow-input
          id="profile-user-birthdate"
          :value="localFilters.to_date"
          :label="$t('wegow.filters.toDate')"
          :small-label="true"
          type="date"
          background-input="bg-transparent"
          @update:value="checkDate($event, 'to_date')"
        />
      </div>
    </div>
    <div
      v-if="
        openedSections &&
          (localFilters.type === 'concerts' ||
            localFilters.type === 'festivals' ||
            localFilters.type === 'both' ||
            localFilters.type === 'venues')
      "
      class="section flex flex-col"
    >
      <h3 class="mb-2">{{ $t("wegow.filters.city") }}</h3>
      <cities-search
        id="profile-user-location"
        :value="{
          id: 0,
          name: '',
          place_id: '',
          longitude: 0,
          latitude: 0
        }"
        :placeholder="$t('wegow.profile.settings.formLocation')"
        background-color="bg-grayish-blue"
        border-input="border-grayInputBorder"
        height="h-[33px]"
        @update:value="selectCity($event)"
      />
      <div class="w-full flex flex-col">
        <span
          v-for="city in localFilters.cities"
          :key="city.place_id"
          class="flex justify-between mt-2"
        >
          {{ city.name }}
          <span class="delete cursor-pointer" @click="selectCity(city)">X</span>
        </span>
      </div>
    </div>
    <div
      v-if="
        openedSections &&
          (localFilters.type === 'concerts' ||
            localFilters.type === 'festivals' ||
            localFilters.type === 'both')
      "
      class="section flex flex-col"
    >
      <h3 class="mb-2">{{ $t("wegow.filters.venue") }}</h3>
      <w-venue-selector
        id="venue-selector"
        background-select="background-transparent"
        :option-selected="''"
        padding="5px 40px 0 8px"
        height="33px"
        @on-select="selectVenue($event)"
      />
      <div class="w-full flex flex-col">
        <span
          v-for="venue in localFilters.venues"
          :key="venue.id"
          class="flex justify-between mt-2"
        >
          {{ venue.name }}
          <span class="delete cursor-pointer" @click="selectVenue(venue)"
            >X</span
          >
        </span>
      </div>
    </div>
    <div
      v-if="
        openedSections &&
          (localFilters.type === 'concerts' ||
            localFilters.type === 'festivals' ||
            localFilters.type === 'both' ||
            localFilters.type === 'artists')
      "
      class="section flex flex-col"
    >
      <h3>{{ $t("wegow.filters.genre") }}</h3>
      <div class="flex flex-wrap columns-2">
        <wegow-checkbox
          v-for="genre in genres"
          :id="'get-' + genre.name + '-data'"
          :key="genre.id"
          class="w-1/2 mt-4"
          :value="localFilters.genres?.includes(genre.id)"
          :title="genre.name"
          size-width="13px"
          size-height="13px"
          @update:value="selectGenre(genre)"
        />
      </div>
    </div>
    <div
      v-if="
        openedSections &&
          (localFilters.type === 'concerts' ||
            localFilters.type === 'festivals' ||
            localFilters.type === 'both')
      "
      class="section flex flex-col space-y-4"
    >
      <h3>{{ $t("wegow.filters.other") }}</h3>
      <wegow-checkbox
        id="get-cultural-bonus-data"
        :value="localFilters.bono_cultural"
        :title="$t('wegow.filters.culturalBonus')"
        size-width="13px"
        size-height="13px"
        top="3px"
        @update:value="localFilters.bono_cultural = $event"
      />
      <wegow-checkbox
        id="get-sellbyus-data"
        :value="localFilters.sellbyus"
        :title="$t('wegow.filters.sellbyus')"
        size-width="13px"
        size-height="13px"
        top="3px"
        @update:value="localFilters.sellbyus = $event"
      />
      <wegow-checkbox
        id="get-weswap-data"
        :value="localFilters.weswap"
        :title="$t('wegow.filters.weswap')"
        size-width="13px"
        size-height="13px"
        top="3px"
        @update:value="localFilters.weswap = $event"
      />
      <wegow-checkbox
        id="get-recommendation-data"
        :value="localFilters.recommendation"
        :title="$t('wegow.filters.recommendation')"
        size-width="13px"
        size-height="13px"
        top="3px"
        @update:value="localFilters.recommendation = $event"
      />
       <wegow-checkbox
        id="get-recommended-concerts"
        :value="localFilters.recommendedConcerts"
        :title="$t('wegow.filters.recommendedConcerts')"
        size-width="13px"
        size-height="13px"
        top="3px"
        @update:value="localFilters.recommendedConcerts = $event"
      />
    </div>
  </div>
</template>

<script setup>
import WegowInput from "@/components/general/forms/WegowInput";
import WegowCheckbox from "@/components/general/forms/WegowCheckbox";
import CitiesSearch from "@/components/general/forms/selectors/CitiesSearch.vue";
import WVenueSelector from "@/components/general/forms/WVenueSelector.vue";

import { ROUTE_VALUES } from "@/constants.js";
import { ref, watch, onBeforeMount } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useVenue } from "@/composables/useVenue";
import { useFilter } from "@/composables/useFilter";
import { useUser } from "@/composables/useUser";
import { useGeneral } from "@/composables/useGeneral";
import { metas } from "@/plugins/mixins/metas";

const {
  pageConfig,
  currentPage,
  loading,
  getConfig,
  getData,
  changePage
} = useFilter();
const { genres, getGenres } = useGeneral();
const { details, getDetails } = useVenue();
const { getTicketsWeswap } = useUser();
const { t } = useI18n();

const route = useRoute();
const router = useRouter();
const emit = defineEmits(["showSection"]);
const dataType = ref(0);
const routeCondition = ref(route.query.type || route.params.type);

const props = defineProps({
  simple: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    default: "concerts"
  }
});

let debounce = null;

const closeSection = () => {
  return emit("showSection", false);
};

const localFilters = ref({
  genres: [],
  cities: [],
  artist: [],
  venues: [],
  type: "concerts",
  from_date: undefined,
  to_date: undefined,
  recommendedConcerts: false
});
const initialConfig = ref({});
const openedSections = ref(true);
const showPersonalizatedDate = ref(false);
const firstLoad = ref(true);

onBeforeMount(async () => {
  firstLoad.value = true;
  metas.methods.setLanguage();
  metas.methods.setCanonical();
  if (ROUTE_VALUES.festivalStrinigs.includes(routeCondition.value)) {
    dataType.value = 1;
    localFilters.value.type = "festivals";
  } else if (ROUTE_VALUES.artistStrinigs.includes(routeCondition.value)) {
    dataType.value = 2;
    localFilters.value.type = "artists";
  } else if (ROUTE_VALUES.venueStrinigs.includes(routeCondition.value)) {
    dataType.value = 3;
    localFilters.value.type = "venues";
  } else if (ROUTE_VALUES.pageStrinigs.includes(routeCondition.value)) {
    dataType.value = 4;
    localFilters.value.type = "pages";
  } else if (ROUTE_VALUES.usersStrinigs.includes(routeCondition.value)) {
    dataType.value = 5;
    localFilters.value.type = "users";
  }
  await uploadConfig();
  setMetas();
  await getGenres({ ordering: "id" });
  firstLoad.value = false;
});

const filterTitle = () => {
  if (
    ROUTE_VALUES.pageStrinigs.includes(routeCondition.value) &&
    pageConfig.value.title
  ) {
    return pageConfig.value.title?.replace(
      t("wegow.filters.concerts"),
      t("wegow.profile.sections.pages.filterTitle")
    );
  } else if (
    ROUTE_VALUES.venueStrinigs.includes(routeCondition.value) &&
    pageConfig.value.title
  ) {
    return pageConfig.value.title?.replace(
      t("wegow.filters.concerts"),
      t("wegow.profile.sections.venues.title")
    );
  } else if (
    ROUTE_VALUES.artistStrinigs.includes(routeCondition.value) &&
    pageConfig.value.title
  ) {
    return pageConfig.value.title?.replace(
      t("wegow.filters.concerts"),
      t("wegow.profile.sections.artists.title")
    );
  } else if (
    ROUTE_VALUES.festivalStrinigs.includes(routeCondition.value) &&
    pageConfig.value.title
  ) {
    return pageConfig.value.title?.replace(
      t("wegow.filters.concerts"),
      t("wegow.filters.festivals")
    );
  } else if (ROUTE_VALUES.usersStrinigs.includes(routeCondition.value)) {
    return t("wegow.filters.userWegow");
  } else {
    return pageConfig.value.title;
  }
};

const changeDate = type => {
  localFilters.value.from_date = undefined;
  localFilters.value.to_date = undefined;
  if (type === "personalized") {
    if (localFilters.value.date && localFilters.value.date !== type) {
      localFilters.value.date = "personalized";
      showPersonalizatedDate.value = true;
    } else if (showPersonalizatedDate.value) {
      showPersonalizatedDate.value = false;
      localFilters.value.date = undefined;
    } else {
      showPersonalizatedDate.value = true;
    }
  } else {
    showPersonalizatedDate.value = false;
    if (localFilters.value.date === type) {
      localFilters.value.date = undefined;
    } else {
      localFilters.value.date = type;
    }
  }
};

const checkDate = (date, type) => {
  const formatoValido = /^\d{4}-\d{2}-\d{2}$/.test(date);
  if (!formatoValido || Number(date.split("-")[0]) < new Date().getFullYear()) {
    return false;
  }
  localFilters.value[type] = date;
  localFilters.value.date = "personalized";
};

const areEqualLists = (originalList, comparisonList) => {
  return originalList.every(item => comparisonList.includes(item));
};

const changeType = (localFiltersType, selectedType) => {
  const eventGroupTypes = ["concerts", "festivals"];
  const selectionGroup = [localFiltersType, selectedType];

  if (localFiltersType === "both" && eventGroupTypes.includes(selectedType)) {
    localFilters.value.type =
      selectedType === "concerts" ? "festivals" : "concerts";
  } else if (areEqualLists(eventGroupTypes, selectionGroup)) {
    localFilters.value.type = "both";
  } else {
    localFilters.value.type = selectedType;
  }
  currentPage.value = 1;
};
const setMetas = () => {
  // OPEN GRAPH
  metas.methods.setOpenGraph({
    title:
      pageConfig.value.title !== ""
        ? pageConfig.value.title
        : t("general.metas.filterTitle", {
            text: filterTitle()
          }),
    description:
      pageConfig.value?.meta_description !== ""
        ? pageConfig.value.meta_description
        : route.params.cities ||
          route.params.administrative_division ||
          route.params.country
        ? t("general.metas.filterDescriptionLocation", {
            location: (
              route.params.cities ||
              route.params.administrative_division ||
              route.params.country
            ).replace(/\b\w/g, match => match.toUpperCase())
          })
        : t("general.metas.filterDescription"),
    image: "@/public/favicons/favicon-36x36.png"
  });

  // Twitter graph
  metas.methods.setTwitterCard({
    title:
      pageConfig.value.title !== ""
        ? pageConfig.value.title
        : t("general.metas.filterTitle", {
            text: filterTitle()
          }),
    description:
      pageConfig.value?.meta_description !== ""
        ? pageConfig.value.meta_description
        : route.params.city ||
          route.params.administrative_division ||
          route.params.country
        ? t("general.metas.filterDescriptionLocation", {
            location: (
              route.params.city ||
              route.params.administrative_division ||
              route.params.country
            ).replace(/\b\w/g, match => match.toUpperCase())
          })
        : t("general.metas.filterDescription"),
    image: "@/public/favicons/favicon-36x36.png"
  });
  // Set metas
  metas.methods.setMetasHtml(
    {
      title:
        pageConfig.value.meta_title !== ""
          ? pageConfig.value.meta_title
          : t("general.metas.filterTitle", {
              text: filterTitle()
            }),
      description:
        pageConfig.value?.meta_description &&
        pageConfig.value?.meta_description !== ""
          ? pageConfig.value.meta_description
          : route.params.city ||
            route.params.administrative_division ||
            route.params.country
          ? t("general.metas.filterDescriptionLocation", {
              location: (
                route.params.city ||
                route.params.administrative_division ||
                route.params.country
              ).replace(/\b\w/g, match => match.toUpperCase())
            })
          : t("general.metas.filterDescription"),
      alternates: pageConfig.value.alternates
    },
    route,
    router
  );
};

const selectCity = citySelected => {
  if (localFilters.value.cities?.includes(citySelected)) {
    const index = localFilters.value.cities.indexOf(citySelected);
    localFilters.value.cities.splice(index, 1);
  } else {
    localFilters.value.cities.push(citySelected);
  }
};

const selectVenue = venueSelected => {
  if (localFilters.value.venues?.includes(venueSelected)) {
    const index = localFilters.value.venues.indexOf(venueSelected);
    localFilters.value.venues.splice(index, 1);
  } else {
    localFilters.value.venues.push(venueSelected);
  }
};

const selectGenre = genre => {
  if (localFilters.value.genres?.includes(genre.id)) {
    const index = localFilters.value.genres.indexOf(genre.id);
    localFilters.value.genres.splice(index, 1);
  } else {
    localFilters.value.genres.push(genre.id);
  }
  currentPage.value = 1;
};

watch(
  localFilters,
  newValue => {
    if (!firstLoad.value) {
      if (debounce) clearTimeout(debounce);
      if (localFilters.value.weswap) {
        getTicketsWeswap(true, { page_size: 24 });
      }
      debounce = setTimeout(async () => {
        getData(newValue, initialConfig.value);
        let valueToquery = JSON.parse(JSON.stringify(newValue));
        if (
          valueToquery.venues.length !== 0 &&
          Array.isArray(valueToquery.venues)
        ) {
          valueToquery.venues = valueToquery.venues?.map(venue => venue.slug);
        }
        if (valueToquery.cities && Array.isArray(valueToquery.cities)) {
          valueToquery.cities = valueToquery.cities?.map(city => city.id);
        }
        valueToquery.page = currentPage.value;
        router
          .push({
            path: route.path,
            query: valueToquery
          })
          .catch(error => {
            console.error(error);
          });
      }, 100);
    }
  },
  { deep: true }
);
watch(
  currentPage,
  newValue => {
    if (debounce) clearTimeout(debounce);
    debounce = setTimeout(async () => {
      getData(localFilters.value, initialConfig.value);
      let valueToquery = { page: JSON.parse(JSON.stringify(newValue)) };
      if (valueToquery.venues && Array.isArray(valueToquery.venues)) {
        valueToquery.venues = valueToquery.venues?.map(venue => venue.slug);
      }
      if (valueToquery.cities && Array.isArray(valueToquery.cities)) {
        valueToquery.cities = valueToquery.cities?.map(city => city.place_id);
      }
      router
        .push({
          path: route.path,
          query: valueToquery
        })
        .catch(error => {
          console.error(error);
        });
    }, 100);
  },
  { deep: true }
);
watch(
  route,
  async newValue => {
    const changeRouteCondition = newValue.query.type || newValue.params.type;
    if (newValue.query.query) {
      localFilters.value.query = newValue.query.query;
      if (ROUTE_VALUES.festivalStrinigs.includes(changeRouteCondition)) {
        dataType.value = 1;
        localFilters.value.type = "festivals";
      } else if (ROUTE_VALUES.artistStrinigs.includes(changeRouteCondition)) {
        dataType.value = 2;
        localFilters.value.type = "artists";
      } else if (ROUTE_VALUES.venueStrinigs.includes(changeRouteCondition)) {
        dataType.value = 3;
        localFilters.value.type = "venues";
      } else if (ROUTE_VALUES.pageStrinigs.includes(changeRouteCondition)) {
        localFilters.value.type = "pages";
      }
      setMetas();
    }
  },
  { deep: true }
);
const uploadConfig = async () => {
  // TODO: cambiar para que cuando tenga query use los query
  // let urlConfig = {
  //   country: route.params.country,
  //   administrative_division: route.query.administrative_division,
  //   cities: route.query.cities,
  //   venues: route.query.venues,
  //   date: route.query.date,
  //   genres: route.query.genres,
  //   type: isFestival.value ? 1 : 0
  // };
  if (props.simple) {
    localFilters.value.type = props.type;
    let urlConfig = {
      country: "espana",
      administrative_division: route.params.administrative_division,
      cities: route.params.city,
      date: route.params.date,
      genre: route.params.genre,
      users: route.params.users,
      type: dataType.value
    };
    await getConfig(urlConfig);
    if (dataType.value > 1 && initialConfig.value.error) {
      urlConfig.type = 0;
      await getConfig(urlConfig);
    }
  } else {
    let urlConfig = {
      country: route.params.country,
      administrative_division: route.params.administrative_division,
      cities: route.params.city,
      date: route.params.date,
      genre: route.params.genre,
      users: route.params.users,
      type: dataType.value
    };
    // Comprobación si el type es mayor de 1 para que el endpoint no devuelva error
    // TODO: Cambiar cuando se cree en el backend el type=2,3,4
    await getConfig(urlConfig);
    if (dataType.value > 1 && initialConfig.value.error) {
      urlConfig.type = 0;
      await getConfig(urlConfig);
    }

    // Continue configuration of filters
    if (pageConfig.value.locations) {
      initialConfig.value.administrative_division = pageConfig.value.locations
        .administrative_division
        ? pageConfig.value.locations.administrative_division
        : undefined;
      initialConfig.value.places = pageConfig.value.locations.city
        ? [pageConfig.value.locations.city]
        : undefined;
      initialConfig.value.country = pageConfig.value.locations.country
        ? pageConfig.value.locations.country
        : undefined;
    }

    if (pageConfig.value.genres?.find(genre => genre.selected)) {
      localFilters.value.genres = pageConfig.value.genres?.find(
        genre => genre.selected
      )?.id;
    }
    localFilters.value.dates = pageConfig.value.dates?.find(
      item => item.selected
    )?.key;
  }

  localFilters.value = { ...localFilters.value, ...route.query };
  if (route.query.page) {
    changePage(route.query.page);
  }

  if (localFilters.value.genres && !Array.isArray(localFilters.value.genres)) {
    localFilters.value.genres = [localFilters.value.genres];
  }
  if (localFilters.value.venues && !Array.isArray(localFilters.value.venues)) {
    localFilters.value.venues = [localFilters.value.venues];
  }
  if (localFilters.value.genres.length) {
    localFilters.value.genres = localFilters.value.genres.map(Number);
  }
  if (localFilters.value.date === "personalized") {
    showPersonalizatedDate.value = true;
  }
  let venues = [];
  for (const venueSlug of localFilters.value.venues) {
    await getDetails(venueSlug);
    venues.push(details.value);
  }
  localFilters.value.venues = venues;
  localFilters.value.cities = [];

  getData(localFilters.value, initialConfig.value);
  // Set metas
  setMetas();
};
</script>

<style lang="scss" scoped>
.filters-section-container {
  background-color: $backgroundGrey;
  border-radius: 5px;
  width: 400px;
  height: fit-content;
  @media screen and (max-width: $screen-md) {
    overflow: scroll;
    height: 100%;
  }
  .section {
    border-top: 1px solid #404256;
    padding: 23px;
    &:first-child {
      border-top: 0px solid #404256;
    }
    h2 {
      font-weight: 600;
      font-size: 25px;
      line-height: 30px;
    }
    h3 {
      font-weight: 600;
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 11px;
      color: white;
    }
    .delete {
      color: $red;
    }
  }
  .section:nth-child(2) {
    border-top: unset;
  }
}
</style>
